import { Button } from '@codegouvfr/react-dsfr/Button';
import { FILE_TYPE_COLORS } from '@common/config';
import { useOfaFichiers } from '@common/hooks/organisme';
import {
  OrganismeFichierType,
  OrganismeStatutType,
  useDownloadOrganismeFichierMutation,
  useResendHabilitationMutation,
} from '@common/services';
import { appToast } from '@common/ui/toast';
import React from 'react';
import { FileItem } from '../../file';
import { Panel } from '../base/Panel';

export const OfaFilesPanel = ({ organismeId, organismeStatut, withHabilitationButton }: OfaFilesPanelProps) => {
  const { filesMap } = useOfaFichiers({ organismeId });

  const [downloadOrganismeFichier] = useDownloadOrganismeFichierMutation();
  const [resendHabilitation, { isLoading }] = useResendHabilitationMutation();

  const habilitationFile = filesMap.HABILITATION;
  const delegateFile = filesMap.DELEGATION_POUVOIR;
  const attestationFile = filesMap.ATTESTATION_REPRESENTANT;

  const filesMapSize = Object.keys(filesMap).length;

  const handleResendHabilitation = async () => {
    await resendHabilitation({ id: organismeId });
    appToast.info('La demande d\'habilitation a bien été renvoyée.');
  };

  const handleDownloadFichier = (fichierType: OrganismeFichierType) => {
    downloadOrganismeFichier({ id: organismeId, fichierType });
  };

  return (
    <Panel title={'Documents'}>

      <div className={'flex flex-col gap-4 py-4'}>

        {(filesMapSize === 0) && (
          <span>Aucun fichier</span>
        )}

        {(!!withHabilitationButton && (organismeStatut !== OrganismeStatutType.REFUS)) && (
          <div className={'mt-2'}>
            <Button priority="secondary"
                    disabled={isLoading}
                    onClick={handleResendHabilitation}>Renvoyer une demande
              d'habilitation</Button>
          </div>
        )}

        {(habilitationFile) && (
          <FileItem title="Habilitation"
                    subType={habilitationFile.subType}
                    downloadOptions={{
                      fn: () => handleDownloadFichier(habilitationFile.type),
                    }}
                    dateModification={habilitationFile.dateModification}
                    fileBackgroundColor={FILE_TYPE_COLORS[habilitationFile.type]} />
        )}

        {(attestationFile) && (
          <FileItem title="Attestation du représentant légal"
                    subType={attestationFile.subType}
                    downloadOptions={{
                      fn: () => handleDownloadFichier(attestationFile.type),
                    }}
                    dateModification={attestationFile.dateModification}
                    fileBackgroundColor={FILE_TYPE_COLORS[attestationFile.type]} />
        )}

        {(delegateFile) && (
          <FileItem title="Délégation de pouvoir"
                    subType={delegateFile.subType}
                    downloadOptions={{
                      fn: () => handleDownloadFichier(delegateFile.type),
                    }}
                    dateModification={delegateFile.dateModification}
                    fileBackgroundColor={FILE_TYPE_COLORS[delegateFile.type]} />
        )}
      </div>
    </Panel>
  );
};

interface OfaFilesPanelProps {
  organismeId: number;
  organismeStatut: OrganismeStatutType;
  withHabilitationButton?: boolean;
}